const BagIcon = () => {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.50648 4.76505C5.50638 4.76009 5.50633 4.75513 5.50633 4.75015V3.75015C5.50633 1.67908 7.18526 0.000152588 9.25633 0.000152588C11.3274 0.000152588 13.0063 1.67908 13.0063 3.75015V4.75015C13.0063 4.75513 13.0063 4.76009 13.0062 4.76505C14.2934 4.80369 15.0811 4.94255 15.6825 5.44163C16.5156 6.1331 16.7351 7.30354 17.174 9.64442L17.924 13.6444C18.5412 16.9361 18.8498 18.582 17.9501 19.6661C17.0504 20.7502 15.3758 20.7502 12.0268 20.7502H6.48589C3.13683 20.7502 1.4623 20.7502 0.562583 19.6661C-0.337134 18.582 -0.0285373 16.9361 0.588656 13.6444L1.33866 9.64442C1.77757 7.30354 1.99703 6.1331 2.8302 5.44163C3.43155 4.94255 4.21922 4.80369 5.50648 4.76505ZM7.00633 3.75015C7.00633 2.50751 8.01369 1.50015 9.25633 1.50015C10.499 1.50015 11.5063 2.50751 11.5063 3.75015V4.75015C11.5063 4.75014 11.5063 4.75016 11.5063 4.75015C11.4311 4.75013 11.3546 4.75015 11.2768 4.75015H7.23589C7.15811 4.75015 7.0816 4.75015 7.00633 4.75018C7.00633 4.75017 7.00633 4.75019 7.00633 4.75018V3.75015Z"
        fill="#4998F7"
      />
    </svg>
  );
};
export default BagIcon;
